import { ApplicationState, resetAllStores } from "../../store";
import { getIsUserAuthenticated } from "../../store/Login/selectors";
import { getIntroductionText } from "../../store/ClinicInformation/selectors";

import { Routes } from "../../constants/routes";
import { changeLanguage } from "../../store/LanguageLocale/actions";
import { connect } from "react-redux";
import { Introduction } from "./Introduction.component";
import { Dispatch } from "redux";
import { IIntroductionMapStateProps, IIntroductionMapDispatchProps } from "./Types";
import { toggleSnackBarPopupVisibility } from "../../store/SnackBarPopup/actions";
import { getHealthCardNumberAcquisitionMode } from "../../store/AcquireHealthCardNumber/selectors";
import { getLanguageCode, getLanguageResourceGeneralStrings } from "../../store/LanguageLocale/selector";
import { push } from "../../store/Routing/actions";

const mapStateToProps = (state: ApplicationState): IIntroductionMapStateProps => {
    return {
        clinicName: state.clinicInformation.clinicName,
        isUserAuthenticated: getIsUserAuthenticated(state.login),
        introductionMessages: getIntroductionText(state.clinicInformation),
        acquiringMethod: getHealthCardNumberAcquisitionMode(state.acquireHealthCardNumber),
        lang: getLanguageCode(state.localeText),
        text: getLanguageResourceGeneralStrings(state.localeText)
    }
};

const mapDispatchToProps = (dispatch: Dispatch): IIntroductionMapDispatchProps => ({
    returnToLoginPage: () => {
        dispatch(push(Routes.root));
    },

    toIntroductionPage: () => {
        dispatch(push(Routes.introduction));
    },

    changeLanguageLocal: (lang: string) => {
        dispatch(changeLanguage(lang))
    },

    resetStoreData: () => {
        dispatch(resetAllStores());
    },

    showInactivityPopup: () => {
        dispatch(toggleSnackBarPopupVisibility(true))
    }
});

export default connect<IIntroductionMapStateProps, IIntroductionMapDispatchProps, void>(mapStateToProps, mapDispatchToProps)(Introduction);


// WEBPACK FOOTER //
// ./src/components/Introduction/Introduction.container.ts